// removed by extract-text-webpack-plugin
module.exports = {"extra-large":"1920px","large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile-l":"640px","mobile-s":"320px","white":"#ffffff","dark-purple":"#4a2e5e","red":"#e40000","dark-red":"#a30000","dark-green":"#008300","background-grey":"#f6f6f6","wrapper":"_5MMHYPqxn0qCoLm0UO9HW","container":"_3hq4N1jpoGptEp43hdcrJN","title":"_1rqXFJHgBaIQUPL0PKKU2u","description":"JEoZYN1cr7c3U1OJsgFmX","descriptionItems":"_1T2RdbbvX8Rkart2c1mpDJ","link":"_2X4zxW0ydlxRKcDDw9srxx","illustration":"_1Qu5imVhNdjrXoTaRG_ndc","v3":"_3wqT5wd7hMRAfd_vY_ToAN"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Hotspots/Landing/HotspotA/HotspotA.css
// module id = 1463
// module chunks = 0